var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvatagesGridItemBg = function SvgAdvatagesGridItemBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 590,
    height: 396,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    y: 380,
    fill: "#F4C678",
    rx: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    x: 575,
    y: 65,
    fill: "#82BFF0",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6676D6",
    d: "M522 26.5C522 11.865 533.864 0 548.5 0S575 11.865 575 26.5v1c0 14.636-11.864 26.5-26.5 26.5S522 42.136 522 27.5z"
  })));
};
export { SvgAdvatagesGridItemBg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkwIiBoZWlnaHQ9IjM5NiIgdmlld0JveD0iMCAwIDU5MCAzOTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHk9IjM4MCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE2IiByeD0iNy41IiBmaWxsPSIjRjRDNjc4Ii8+CjxyZWN0IHg9IjU3NSIgeT0iNjUuMDAwMiIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE2IiByeD0iNy41IiBmaWxsPSIjODJCRkYwIi8+CjxwYXRoIGQ9Ik01MjIgMjYuNTAwMkM1MjIgMTEuODY0NyA1MzMuODY0IDAuMDAwMjQ0MTQxIDU0OC41IDAuMDAwMjQ0MTQxQzU2My4xMzYgMC4wMDAyNDQxNDEgNTc1IDExLjg2NDcgNTc1IDI2LjUwMDJWMjcuNTAwMkM1NzUgNDIuMTM1OCA1NjMuMTM2IDU0LjAwMDIgNTQ4LjUgNTQuMDAwMkM1MzMuODY0IDU0LjAwMDIgNTIyIDQyLjEzNTggNTIyIDI3LjUwMDJWMjYuNTAwMloiIGZpbGw9IiM2Njc2RDYiLz4KPC9zdmc+Cg==";